import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TrimPipe } from '../../pipes/trim.pipe';
// This Module's Components
import { AppSecondaryLinksContentModule } from '../app-secondary-links-content/app-secondary-links-content.module';
import { AppNavigationLinksComponent } from './app-navigation-links.component';

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    AppSecondaryLinksContentModule
  ],
  declarations: [AppNavigationLinksComponent, TrimPipe],
  exports: [AppNavigationLinksComponent, TrimPipe]
})
export class AppNavigationLinksModule {}
